import * as H from 'history';
import React, { ReactNode } from 'react';
import { makeLocalizedUrl } from 'utils/localizedLinks';

import { history } from '../wlHistory';

type LocalizedNoIndexLinkType = {
  to: H.LocationDescriptor;
  isReplace?: boolean;
  children: ReactNode;
  analyticsCallback?: () => void;
  [name: string]: any;
};

const onClick = (to, isReplace, analyticsCallback) => (e) => {
  if (!!analyticsCallback && typeof analyticsCallback === 'function') {
    analyticsCallback();
  }

  if (isReplace) {
    history.replace(to);
  } else {
    history.push(to);
  }
};

const LocalizedNoIndexLink = ({
  to,
  isReplace = false,
  children,
  analyticsCallback,
  ...rest
}: LocalizedNoIndexLinkType) => {
  let localizedTo;
  if (typeof to === 'string') {
    localizedTo = makeLocalizedUrl(to);
  } else if (typeof to === 'object') {
    localizedTo = {
      ...to,
      pathname: makeLocalizedUrl(to.pathname),
    };
  }

  return (
    <button
      onClick={onClick(localizedTo, isReplace, analyticsCallback)}
      {...rest}
    >
      {children}
    </button>
  );
};

export default LocalizedNoIndexLink;
